var React = require('react');

function TwitchIconInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Deviant Robot Twitch"),React.createElement("path",{"fillRule":"nonzero","d":"M10.773-.709L.945 25.379v104.337h36.018v19.575h19.664l19.645-19.575h29.475l39.308-39.114V-.709H10.773zm13.093 13.036h108.09v71.74l-22.933 22.83H73l-19.639 19.548v-19.548H23.866v-94.57zm36.032 65.227H73V38.428H59.898v39.126zm36.026 0h13.099V38.428H95.924v39.126z","key":1})]);
}

TwitchIconInline.defaultProps = {"fillRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"1.414","clipRule":"evenodd","viewBox":"0 0 146 151"};

module.exports = TwitchIconInline;

TwitchIconInline.default = TwitchIconInline;
